import $ from 'jquery';
import stamp from './stamp.txt';

$('[stamp]').not('[stamp-vue]').each(function () {
    const $stampHook = $(this);
    const $parent = $stampHook.parent();
    const classes = $stampHook.data('stamp-class');
    $parent.addClass('position-relative').addClass('overflow-x-visible');

    const $stamp = $('<div class="stamp stamp--overlay"></div>');
    $stamp.append(stamp);
    $stamp.addClass(classes);

    $stampHook.replaceWith($stamp);

    // add bottom margin to the parent element.
    const bottomMargin = parseInt($parent.css('margin-bottom')) || 0;
    $parent.css('margin-bottom', $stamp.outerHeight() / 2 + bottomMargin);
});
